import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'smileySVG',
}) => (
  <svg
    viewBox="0 0 216.2 214"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M108.3,6.9C53,6.9,8.2,51.8,8.2,107s44.7,100.1,100,100.1S208.3,162.3,208.3,107S163.6,6.9,108.3,6.9z M143.1,60.3
	c8.2,0,15.3,7.4,15.1,15.6c-0.3,8-7.2,14.8-15.2,14.9c-1.6,0-3.1-0.3-4.6-0.8c-6.2-2-10.9-8-10.8-14.6
	C127.7,67.2,134.9,60.2,143.1,60.3z M71.7,60.3C71.7,60.3,71.7,60.3,71.7,60.3C71.8,60.3,71.8,60.3,71.7,60.3
	c8.3,0,15.4,7.2,15.4,15.3c0,8.1-7.4,15.2-15.5,15.1c-4.7-0.1-9.1-2.6-11.9-6.2c-0.5-0.7-1-1.4-1.4-2.1c0,0,0,0,0-0.1
	c-0.1-0.1-0.1-0.2-0.2-0.3c-1.1-2.1-1.7-4.4-1.6-6.8C56.8,67.1,63.8,60.3,71.7,60.3z M162.3,159.1c-13.4,15.3-33.1,25-54.9,25
	c-39.5,0-71.7-31.4-72.7-70.8c-0.1-2.4,0.4-4.5,2.2-5.5c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.3-0.1,0.5-0.2
	c0,0,0,0,0,0c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.4,0c0.3,0,0.5,0,0.7,0
	c3.4,0,4.4,2.6,4.6,5.8c1.4,26,15.2,46.3,36.7,56c6.6,2.9,13.9,4.9,21.7,5.7c30.6,3.2,61.4-20.3,66.7-50.9c0.6-3.4,1-6.9,1.2-10.4
	c0.2-3.3,0.7-6.3,4.7-6.3c1.1,0,1.9,0.3,2.6,0.6c2,1,2.4,3.5,2.3,6.2C179.7,131.1,173,146.9,162.3,159.1z"
    />
  </svg>
);

export default SVG;
